import request from '@/utils/util.js'

export function getPunchClockDataAPI(data) {
	return request.get('/patrol/list', data)
}